function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-20">
      <div className="max-w-7xl mx-auto px-6 text-center">

        <h3 className="text-white text-4xl font-semibold mb-6 logo-great">
          <span className="logo-my">My</span>
          <span className="logo-trip">Trip</span>
        </h3>

        <p className="mb-6">
          Discover premium stays with intelligent geo-search.
        </p>

        <p className="text-sm">
          © 2026 MyTrip. All rights reserved.
        </p>

      </div>
    </footer>
  );
}

export default Footer;
